/*
 * Смотрит ли человек на приложение прямо сейчас.
 *
 * В браузере и в установленной веб-версии на это отвечает сама страница:
 * свёрнутая, закрытая другой вкладкой или погашенным экраном, она «скрыта».
 *
 * В приложении для Windows страница не скрывается никогда. Окну там нарочно
 * запрещено засыпать (`backgroundThrottling: false` в apps/desktop/src/main.ts):
 * иначе в свёрнутом окне замирали бы звонок и отсчёт обновления. Плата за это —
 * `document.visibilityState` остаётся «visible», даже когда окно убрано в трей.
 * Приложение из-за этого вело себя так, будто человек не отходит от компьютера:
 * сервер не слал уведомления на телефон, пока оно запущено; сообщение в открытом
 * чате приходило без уведомления и звука и сразу отмечалось прочитанным.
 *
 * Поэтому в оболочке о присутствии говорит другое: окно сейчас активно. Окно
 * на экране, но не в фокусе, считается оставленным — так же поступают остальные
 * настольные мессенджеры: лишнее уведомление лучше пропущенного сообщения.
 */
export function appOnScreen(): boolean {
	if (typeof document === 'undefined') return true;
	if (document.visibilityState !== 'visible') return false;
	return !window.andresotDesktop || document.hasFocus();
}

/**
 * Позвать `listener`, когда ответ `appOnScreen` мог измениться.
 *
 * Возвращает отписку. В браузере это одно событие видимости страницы; оболочка
 * Windows его не присылает — там следим за фокусом окна.
 */
export function watchOnScreen(listener: () => void): () => void {
	if (typeof document === 'undefined') return () => undefined;
	document.addEventListener('visibilitychange', listener);
	if (!window.andresotDesktop) {
		return () => document.removeEventListener('visibilitychange', listener);
	}
	window.addEventListener('focus', listener);
	window.addEventListener('blur', listener);
	return () => {
		document.removeEventListener('visibilitychange', listener);
		window.removeEventListener('focus', listener);
		window.removeEventListener('blur', listener);
	};
}
